import api from "../config/api";
import { getErrorMessage } from "../config/errorHelper";

// Le token JWT est injecté automatiquement par l'interceptor dans api.js
// → pas besoin de getAuthHeader() ici

// ─────────────────────────────────────────────
//  NOTIFICATIONS
// ─────────────────────────────────────────────

/**
 * Récupère toutes les notifications de l'utilisateur connecté,
 * triées de la plus récente à la plus ancienne.
 */
export const getAllNotifications = async () => {
  try {
    const response = await api.get("/notifications");
    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

/**
 * Retourne le nombre de notifications non lues.
 * Utilisé pour le badge (compteur) sur la cloche dans la Topbar.
 */
export const getUnreadCount = async () => {
  try {
    const response = await api.get("/notifications/unread-count");
    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

/**
 * Marque une notification spécifique comme lue.
 * @param {string} id - UUID de la notification
 */
export const markAsRead = async (id) => {
  try {
    const response = await api.put(`/notifications/${id}/read`);
    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

/**
 * Marque toutes les notifications non lues de l'utilisateur comme lues.
 */
export const markAllAsRead = async () => {
  try {
    const response = await api.put("/notifications/read-all");
    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};
